class ProductRecommendations extends HTMLElement {
	observer = undefined;

	constructor() {
		super();
	}

	connectedCallback() {
		this.initializeRecommendations(this.dataset.productId);
	}

	initializeRecommendations(productId) {
		this.observer?.unobserve(this);
		this.observer = new IntersectionObserver(
			(entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);
				this.loadRecommendations(productId);
			},
			{ rootMargin: '0px 0px 400px 0px' }
		);
		this.observer.observe(this);
	}

	initSwiper() {
		const swiperElement = this.querySelector('swiper-container');
		if (!swiperElement) {
			return;
		}

        const swiperConfig = {
			slidesPerView: 'auto',
			spaceBetween: 16,
			grabCursor: true,
			slidesOffsetBefore: 20,
			slidesOffsetAfter: 20,
			scrollbar: {
				draggable: true,
			},
			breakpoints: {
				1024: {
					slidesOffsetBefore: 32,
					slidesOffsetAfter: 32,
				},
				1280: {
					slidesPerView: 4,
					spaceBetween: 20,
					slidesOffsetBefore: 0,
					slidesOffsetAfter: 0,
				},
			},
		};
        Object.assign(swiperElement, swiperConfig);
        swiperElement.initialize();
	}

	loadRecommendations(productId) {
		console.log('loading Recommendations', productId);
		fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
			.then((response) => response.text())
			.then((text) => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('product-recommendations');

				if (recommendations?.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML;
				}

				this.initSwiper();
			})
			.catch((e) => {
				console.error(e);
			});
	}
}

customElements.define('product-recommendations', ProductRecommendations);
